angular.module("rjmNg.common.api").factory "GoogleAnalyticsMetadata", [
  "$cacheFactory"
  "$http"
  (
    $cacheFactory
    $http
  ) ->

    TYPE_MAP =
      DIMENSION: "dimensions"
      METRIC: "metrics"

    query = (key) ->
      $http
        # Don't use the default $http cache so this data isn't cleared when the
        # user logs out.
        cache: $cacheFactory.get("googleAnalyticsMetadata")
        isArray: true
        method: "GET"
        params: {key}
        url: "https://www.googleapis.com/analytics/v3/metadata/ga/columns"
      .then ({data}) ->
        data

    queryWithGrouping = (key) ->
      query(key).then (data) ->
        columnsByType = {}

        for item in data.items
          type = TYPE_MAP[item.attributes.type]
          continue unless type?

          columnsByType[type] ?= {}
          columnsByType[type][item.attributes.group] ?= []
          columnsByType[type][item.attributes.group].push
            id: item.id

        metrics: columnsByType.metrics ? {}
        dimensions: columnsByType.dimensions ? {}

    # Queries metadata, and returns an object whose keys are metadata item ids
    # and whose values are the corresponding entries.
    queryIdMap = (key) ->
      query(key).then (data) ->
        items = {}
        for item in data.items
          items[item.id] = item

        items

    {
      query
      queryIdMap
      queryWithGrouping
    }
]
